import * as R from 'ramda';
import { fromJS } from 'immutable';
import * as appraiserSettingsActions from '../actions/appraiserSettings';
import { SUCCESS, START, ERROR } from '../actions/global';
import { fetchingState } from '@constants';

const initialState = {
  appraiserTypes: {
    data: [],
    state: null,
  },
  appraiserSettings: {
    data: [],
    state: null,
  },
};

export default (state = fromJS(initialState), action) => {
  switch (action.type) {
    case appraiserSettingsActions.FETCH_APPRAISER_TYPES[START]:
      return state.setIn(['appraiserTypes', 'state'], fetchingState.FETCHING);
    case appraiserSettingsActions.FETCH_APPRAISER_TYPES[SUCCESS]:
      return state
        .setIn(
          ['appraiserTypes', 'data'],
          fromJS(R.pathOr([], ['data', 'results'], action)),
        )
        .setIn(['appraiserTypes', 'state'], fetchingState.LOADED);
    case appraiserSettingsActions.FETCH_APPRAISER_TYPES[ERROR]:
      return state.setIn(['appraiserTypes', 'state'], fetchingState.ERROR);

    case appraiserSettingsActions.FETCH_APPRAISER_SETTINGS[START]:
      return state.setIn(
        ['appraiserSettings', 'state'],
        fetchingState.FETCHING,
      );
    case appraiserSettingsActions.FETCH_APPRAISER_SETTINGS[SUCCESS]:
      return state
        .setIn(
          ['appraiserSettings', 'data'],
          fromJS(R.pathOr([], ['data', 'results'], action)),
        )
        .setIn(['appraiserSettings', 'state'], fetchingState.LOADED);
    case appraiserSettingsActions.FETCH_APPRAISER_SETTINGS[ERROR]:
      return state.setIn(['appraiserSettings', 'state'], fetchingState.ERROR);

    case appraiserSettingsActions.INSERT_APPRAISER_SETTINGS[START]:
      return state.setIn(
        ['appraiserSettings', 'state'],
        fetchingState.FETCHING,
      );
    case appraiserSettingsActions.INSERT_APPRAISER_SETTINGS[SUCCESS]:
      return state
        .setIn(
          ['appraiserSettings', 'data'],
          fromJS(R.pathOr([], ['data', 'results'], action)),
        )
        .setIn(['appraiserSettings', 'state'], fetchingState.LOADED);
    case appraiserSettingsActions.INSERT_APPRAISER_SETTINGS[ERROR]:
      return state.setIn(['appraiserSettings', 'state'], fetchingState.ERROR);
    default:
      return state;
  }
};
